'use strict';

import angular from 'angular';

export default angular.module('conduuApp.constants', [])
  .constant('appConfig', require('../../server/config/environment/shared'))
  .name;



// WEBPACK FOOTER //
// ./client/app/app.constants.js